import { IconType } from 'react-icons'

import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { NoContentResponse } from '@/types/api'
import {
  CreateReferralStatusRequest,
  UpdateReferralStatusRequest,
} from '@/types/requests/referral-status'
import { ReferralStatusItem } from '@/types/responses/common-data'
import { ReferralStatusCollection } from '@/types/responses/referral-status'

export interface ReferralStatusStyles {
  icon: IconType
  color: {
    light: string
    dark: string
  }
}

class ReferralStatusService {
  private readonly endpoint = `${API_PATH_INTERNAL}/referral-mapped-statuses`

  async getDefaultStatuses(): Promise<ReferralStatusCollection> {
    const response = await apiService.get(`${this.endpoint}/default-statuses`)
    return response.data
  }

  async createReferralStatus(
    request: CreateReferralStatusRequest,
  ): Promise<ReferralStatusItem> {
    const response = await apiService.post(`${this.endpoint}`, request)
    return response.data
  }

  async deleteReferralStatus(referralStatusId: ID): Promise<NoContentResponse> {
    const response = await apiService.delete(
      `${this.endpoint}/${referralStatusId}`,
    )
    return response.data
  }

  async updateReferralStatus(
    referralStatusId: ID,
    request: UpdateReferralStatusRequest,
  ): Promise<ReferralStatusItem> {
    const response = await apiService.patch(
      `${this.endpoint}/${referralStatusId}`,
      request,
    )
    return response.data
  }
}

const referralStatusService = new ReferralStatusService()

export default referralStatusService
